import { render, staticRenderFns } from "./Detail-Claim.vue?vue&type=template&id=585592f9&scoped=true"
import script from "./Detail-Claim.vue?vue&type=script&lang=js"
export * from "./Detail-Claim.vue?vue&type=script&lang=js"
import style0 from "./Detail-Claim.vue?vue&type=style&index=0&id=585592f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585592f9",
  null
  
)

export default component.exports